export type ConversionEventName = 'linkClick' | 'favoriteAdded';

export default function sendConversionBeacon(
  conversionURL: string | undefined,
  eventName?: ConversionEventName,
) {
  if (!conversionURL) return;

  const url = eventName
    ? `${conversionURL}&eventName=${encodeURIComponent(eventName)}`
    : conversionURL;

  navigator.sendBeacon(url);
}
